import { AxiosError } from 'axios';
import localization from '@/constant/localization';
import { API_GATE_WAY } from '@/constant/routes';

export function addZeroIfUnder10(number: number | string) {
  if (+number < 10) {
    return `0${number}`;
  }
  return number;
}

export function getFromLocalStorage(key: string): string | null {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem(key);
  }
  return null;
}
export function getFromSessionStorage(key: string): string | null {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    return sessionStorage.getItem(key);
  }
  return null;
}

export function deleteFromSessionStorage(key: string): void {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    return sessionStorage.removeItem(key);
  }
  return;
}

export function setToSessionStorage(key: string, value?: string) {
  return sessionStorage.setItem(key, value || '');
}

export function setToLocalStorage(key: string, value?: string) {
  return localStorage.setItem(key, value || '');
}

export function deleteFromLocalStorage(key: string): void {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.removeItem(key);
  }
  return;
}

export function persianDateGenerator(date: Date) {
  const persianDate = new Intl.DateTimeFormat('fa', {
    year: 'numeric',
    month: 'numeric', // or long for 'شهریور'
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    weekday: 'long',
  }).formatToParts(date);
  const year = persianDate[2].value;
  const month = persianDate[4].value;
  const day = persianDate[6].value;
  const weekday = persianDate[0].value;
  // return `${weekday} ${day} ${month} ${year}`;
  return `${year}/${month}/${day}`;
}
export function persianDateGenerator2(date: Date, type?: 'noDash') {
  const persianDate = new Intl.DateTimeFormat('fa', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    weekday: 'long',
  }).formatToParts(date);
  const year = persianDate[0].value;
  const month = persianDate[2].value;
  const day = persianDate[4].value;
  const weekday = persianDate[6].value;
  const hour = persianDate[8].value;
  const minute = persianDate[10].value;
  if (type === 'noDash') {
    return `${weekday} ${day} ${month} ${year}  ${hour}:${minute}`;
  } else return `${weekday} ${day} ${month} ${year} - ${hour}:${minute}`;
}
export function APIUrlGenerator(route: string, qry?: object): string {
  const query = qry || {};
  const queryKeys = Object.keys(query);
  let apiUrl = `${API_GATE_WAY}${route}`;

  queryKeys?.map((item, index) => {
    if (index === 0) {
      apiUrl += '?';
    }
    // @ts-ignore
    if (query[item] !== null) {
      if (queryKeys?.length !== index + 1) {
        // @ts-ignore
        apiUrl += item + '=' + query[item] + '&';
      } else {
        // @ts-ignore
        apiUrl += item + '=' + query[item];
      }
    }
  });
  return apiUrl;
}
export function isIOS(): boolean {
  if (typeof window === `undefined` || typeof navigator === `undefined`) {
    return false;
  }

  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function convertRialToToman(rial: number) {
  return rial / 10;
}
export function convertTomanToRial(rial: number) {
  return rial * 10;
}
export function rialPostFix(rial: number) {
  const rialComma = rial?.toLocaleString('fa');
  return `${rialComma}  ${localization.rial}`;
}
export function tomanPostFix(toman: number) {
  const tomanComma = toman?.toLocaleString('fa');
  return `${tomanComma}  ${localization.toman}`;
}
export function currency(rial: number) {
  if (rial >= 0) {
    const rialComma = rial.toLocaleString('fa');
    return `${rialComma}`;
  }
}
export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function preventLetters(x: string) {
  return x.replace(/\D/g, '');
}
export function removeCommas(x: string) {
  return x.split(',').join('');
}
export function isMobile() {
  return window.innerWidth < 768;
}

export function isDesktop() {
  return window.innerWidth > 1023;
}
export function getAxiosErrorMessageText(error: Error) {
  const returnError = error as AxiosError;
  const responseData = returnError?.response?.data as { [key in string]: string };
  if (responseData?.message) {
    return responseData?.message;
  }
  return returnError.message;
}

export function getLocationStandardURL(latitude: number, longitude: number) {
  if (isIOS()) {
    return `https://maps.apple.com/?ll=${latitude},${longitude}`;
  } else {
    return `geo:${latitude},${longitude}`;
  }
}

export function convertToEnglishNumber(num: number | string) {
  return num
    ?.toString()
    .replace(/([۰-۹])/g, (englishNumber) =>
      String.fromCharCode(englishNumber.charCodeAt(0) - 1728),
    );
}

export function isValidNationalCode(nationalCode: string) {
  if (!/^\d{10}$/.test(nationalCode)) return false;
  const check = +nationalCode[9];
  const sum =
    nationalCode
      .split('')
      .slice(0, 9)
      .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
  return sum < 2 ? check === sum : check + sum === 11;
}

export const numberInputProps = (
  callback: (formattedValue: string) => void,
): {
  onChange: React.ChangeEventHandler<HTMLInputElement>;
} => {
  return {
    onChange: (e) => {
      const { value } = e.target;
      let numberValue = value.replace(/,/g, '');
      if (isIOS()) numberValue = convertToEnglishNumber(numberValue);
      if (!isNaN(Number(numberValue)) && Number.isFinite(+numberValue)) {
        const formattedValue =
          Number(numberValue) > 0 ? numberValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
        callback(formattedValue);
      }
    },
  };
};
export function areObjectsEqual(obj1: any, obj2: any) {
  // Check if both inputs are objects
  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false;
  }

  // Check if they have the same number of properties
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1?.length !== keys2?.length) {
    return false;
  }

  // Check if each key-value pair is equal
  for (let key of keys1) {
    // Check if both values are objects, and if so, recursively compare them
    if (
      typeof obj1[key] === 'object' &&
      obj1[key] !== null &&
      typeof obj2[key] === 'object' &&
      obj2[key] !== null
    ) {
      if (!areObjectsEqual(obj1[key], obj2[key])) {
        return false;
      }
    } else if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
}

export function dateUntilFutureDate(
  futureDateStr: Date,
  mode: 'day' | 'minute' | 'second',
  type: 'max' | 'min',
): number {
  const futureDate = new Date(futureDateStr);
  const now = new Date();
  const differenceInMillis = futureDate.getTime() - now.getTime();
  let divider = 1; // 24 * 60 * 60 * 1000;
  switch (mode) {
    case 'day':
      divider = 24 * 60 * 60 * 1000;
      break;
    case 'minute':
      divider = 60 * 1000;
      break;
    case 'second':
      divider = 1000;
  }
  if (type === 'max') {
    return Math.ceil(differenceInMillis / divider);
  } else return Math.floor(differenceInMillis / divider);
}

export function addQueryString(url:string, queryString: {key: string, value: string | null}) {
  if(!queryString.value) return url;
  if(url?.indexOf("?") !== -1){
    return url + `&${queryString.key}=${queryString.value}`;
  } else return url + `?${queryString.key}=${queryString.value}`;
}

export function calcDaysBetween2Date(isoDate: string | number) {
  let current = new Date();
  let date2 = new Date(isoDate);
  let Difference_In_Time =
    date2.getTime() - current.getTime();

  return Math.round(Difference_In_Time / (1000 * 3600 * 24))
}

export function toMilliSecond (time: number) {
  return time * 1000
}

export function isMerchantUpg () {
  return sessionStorage.getItem('mUpg') !== null;
}

export function changeFavicon(href: string): void {
  const rels: string[] = [
    "icon",
    "alternate icon",
    "apple-touch-icon",
    "mask-icon",
  ];

  rels.forEach((rel) => {
    let link = document.querySelector<HTMLLinkElement>(
      `link[rel="${rel}"]`
    );

    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      document.head.appendChild(link);
    }

    link.href = href;
  });
}

export function isZeroAmount(number?: number) {
  return number ? number : 0
}
export function IsUpgData() {
  return sessionStorage.getItem('mUpg')
}